import React from 'react';
import { useSelector } from 'react-redux';
import Tabs from '../../../components/common/tabs';
import './index.scss';

const SearchTop = ({ query, invertedQuery, activeTab, tabsList, onTabSelect }) => {
  const translations = useSelector(store => store.config.Translations);

  return (
    <div className="search-top-container">
      <h2 className="search-title">
        {invertedQuery
          ? `תוצאות עבור ״${invertedQuery}״`
          : `${translations['free_search_results_title']} "${query}"`}
      </h2>

      <Tabs
        activeTab={activeTab}
        tabsList={tabsList}
        onTabSelect={onTabSelect}
      />
    </div>
  );
};

export default SearchTop;
